import React from "react";
import { BaseComponent } from "../../utils/BaseComponent";
import { ParentStateDatasource, DataSourceStateIdle } from "@schneiderpp/utils-endpoint";
import { FormatFloat } from "@schneiderpp/utils-generic";
import { Endpoint } from "@schneiderpp/client-endpoint";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { ds } from "../../DataSource";
import { OverlayProps, Overlay } from "@schneiderpp/utils-components";
import { ROUTER_HOME } from "../home/Router";
import moment from "moment";

interface DetailsState {
    providedSupplyId: number | undefined;
    datasource: {
        Details: ParentStateDatasource<typeof Endpoint.Supply.GetSupplyDetails>;
    };
}

class SupplyDetails extends BaseComponent<RouteComponentProps, DetailsState> {
    state: DetailsState = {
        providedSupplyId: undefined,
        datasource: {
            Details: DataSourceStateIdle
        }
    };

    private dsDetails = ds(Endpoint.Supply.GetSupplyDetails, this, "Details", () => this.context);

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const SupplyId = urlParams.get("SupplyId");
        if (!SupplyId) {
            return;
        }
        const SupplyIdInt = parseInt(SupplyId);
        if (!Number.isInteger(SupplyIdInt)) {
            return;
        }
        this.setState({ providedSupplyId: SupplyIdInt }, () => this.getDetails());
    }

    render() {
        if (!this.state.providedSupplyId) {
            return (
                <div className="page">
                    <div className="page__header">Nie wczytano SupplyId</div>
                </div>
            );
        }
        const dsDetailsData = this.dsDetails.dataSourceStorage;
        if (dsDetailsData.state === "completed") {
            return (
                <>
                    <div className="header">
                        <Link to={ROUTER_HOME.Supplies.List} className="button clear no-left-padding">
                            <span className="button__icon">arrow_back_ios</span> wróć do listy zatowarowań
                        </Link>
                    </div>
                    <div className="page">
                        <div className="page__column-view">
                            <div className="page__column">
                                <div className="page__header">
                                    Zatowarowanie nr {dsDetailsData.response.SupplyId} z dnia{" "}
                                    {moment(dsDetailsData.response.SupplyDate).format("YYYY-MM-DD")}
                                </div>
                                <div className="page-tab-content">
                                    <div className="page-details">
                                        <div className="page-details__label">Id Zatowarowania</div>
                                        <div className="page-details__value">{dsDetailsData.response.SupplyId}</div>
                                    </div>
                                    <div className="page-details">
                                        <div className="page-details__label">Status Zatowarowania</div>
                                        <div className="page-details__value">{dsDetailsData.response.Status.Name}</div>
                                    </div>
                                    <div className="page-details">
                                        <div className="page-details__label">Data Zatowarowania</div>
                                        <div className="page-details__value">
                                            {moment(dsDetailsData.response.SupplyDate).format("YYYY-MM-DD")}
                                        </div>
                                    </div>
                                    <div className="page-details">
                                        <div className="page-details__label">Wartość Zasilenia Konta</div>
                                        <div className="page-details__value">{FormatFloat(dsDetailsData.response.Value)} PKT</div>
                                    </div>
                                    {/* <div className="page-details">
                                        <div className="page-details__label">Wartość Zatowarowania</div>
                                        <div className="page-details__value">{FormatFloat(dsDetailsData.response.ValueElements)} ZŁ</div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="page__column">
                                <div className="page__header">Elementy Zatowarowania</div>
                                <div className="page-table">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="w-3 t-left">Nazwa</th>
                                                <th className="w-3">Ilość</th>
                                                {/* <th className="w-3 t-right">Wartość</th> */}
                                                <th className="w-3 t-right">Bonus</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dsDetailsData.response.Elements.map((element) => (
                                                <tr key={element.SupplyElementId}>
                                                    <td className="t-left">{element.Name}</td>
                                                    <td>{element.Quantity}</td>
                                                    {/* <td className="t-right">{FormatFloat(element.Value)} ZŁ</td> */}
                                                    <td className="t-right">{FormatFloat(element.BonusValue)} PKT</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Overlay {...this.overlayProps} />
                    </div>
                </>
            );
        }
        return (
            <div className="page">
                <Overlay {...this.overlayProps} />
            </div>
        );
    }

    get overlayProps(): OverlayProps {
        if (this.dsDetails.state === "pending" || this.dsDetails.state === "idle") {
            return {
                show: true,
                title: "Ładowanie"
            };
        }
        if (this.dsDetails.state === "error") {
            return {
                show: true,
                title: "Coś poszło nie tak",
                description: typeof this.dsDetails.error === "string" ? this.dsDetails.error : "",
                children: (
                    <div className="overlay__children">
                        <button className="button light" onClick={() => this.getDetails()}>
                            spróbuj ponownie
                        </button>
                    </div>
                )
            };
        }
        return {
            show: false
        };
    }

    private getDetails() {
        if (!this.state.providedSupplyId) {
            return;
        }
        this.dsDetails.request({
            params: { SupplyId: this.state.providedSupplyId }
        });
    }
}

export default withRouter(SupplyDetails);
